/* ==========================================================================
   CandyNats — scroll reveal
   Adds `.cn-in` to any element marked `[data-cn-reveal]` once it scrolls into
   view. Children marked `.cn-reveal-item` (with an optional `--cn-i` index for
   stagger) then animate in via candynats.css. Safe to load multiple times.
   ========================================================================== */
(function () {
  if (window.__cnRevealInit) return;
  window.__cnRevealInit = true;

  var root = document.documentElement;
  // Gate the hidden initial state on JS being present so no-JS users see content.
  root.classList.add('cn-reveal-ready');

  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var supported = 'IntersectionObserver' in window;
  var io = null;

  function show(el) {
    el.classList.add('cn-in');
  }

  if (supported && !reduce) {
    io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            show(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
    );
  }

  function scan() {
    var items = document.querySelectorAll('[data-cn-reveal]:not([data-cn-seen])');
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      el.setAttribute('data-cn-seen', '');
      if (io) {
        io.observe(el);
      } else {
        // No observer / reduced motion: reveal immediately.
        show(el);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Re-scan when sections are added/reordered in the theme editor.
  document.addEventListener('shopify:section:load', scan);
})();
